export enum ComponentId {
  CORRECTNESS_AGREEMENT = "correctnessAgreement",
  CONTACT_AGREEMENT = "contactAgreement",
}
